module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsview page-news-view"
  }, [_c('c-head'), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.topic.title))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("发布于：" + _vm._s(_vm._f("dateFormat")(_vm.topic.create_at)))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "main",
    domProps: {
      "innerHTML": _vm._s(_vm.topic.content)
    }
  }), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("没有相关内容！")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-480000d0!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/newsView.vue
// module id = 34
// module chunks = 1